import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../Redux";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Input from "../../Components/Input";
import Select from "../../Components/Select";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import DateInput from "../../Components/DateInput";
import { MultiSelect } from "react-multi-select-component";
import ErrorContainer from "../../Components/ErrorContainer";
import { getFormData } from "../../../helpers";

const Customers = (params) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const customersData = useSelector(
    (state) => state?.orderInvoicesReducer?.customersData?.customers
  );

  useEffect(() => {
    dispatch(actions?.getCustomersData());
  }, []);

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div className="top-header-sec mb-1">
                  <div className="col-12 mt-3">
                    <h4 className="event-alert br-btm-0">
                      Customer List
                      <div className="clear"></div>
                    </h4>
                    <div className="row justify-content-between align-items-center">
                      <div className="col-md-4">
                        <div className="search-box mt-0">
                          <form type="GET">
                            <input
                              type="text"
                              placeholder="Search"
                              name="keyword1"
                            />
                            <input type="submit" />
                          </form>
                        </div>
                      </div>

                      <div className="col-md-8 align-right details-button">
                        <div className="field text-right mt-3 mt-sm-0">
                          <div className="uploadBtn">
                            {" "}
                            <input
                              onChange={(e) => {
                                const file = getFormData({
                                  customer_file: e.target.files[0],
                                });
                                dispatch(actions.postCustomerFile(file));
                              }}
                              type="file"
                              name="data[payee_file]"
                              id="payee_file"
                              class="inputfile inputfile-2"
                              data-multiple-caption="{count} files selected"
                            />
                            <label
                              class="btn green-btn-revert upload-icon"
                              for="payee_file"
                            >
                              {" "}
                              <span class="i-icon"> </span> <span>Upload</span>
                            </label>
                          </div>
                          <button
                            onClick={() => {
                              dispatch(actions?.getDownloadCustomersData());
                            }}
                            id="download"
                            class="btn green-btn-revert download-icon"
                            onclick="downloadPayees();"
                          >
                            <i class="i-icon"> </i> Download
                          </button>
                          <button
                            onClick={() =>
                              history.push(
                                "/order/customers/new-customer",
                                "add"
                              )
                            }
                            class="btn green-btn-revert add-plus addSp mx-0"
                            id="addCount"
                            type="button"
                          >
                            <i class="i-icon"> </i> Add Customer
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mx-0 mt-3">
              <div className="container px-0">
                <div className="shadowclass mt-0">
                  <div className="table-responsive general-setting saved_order_ms">
                    <div className="orderList">
                      <div className="col d-flex align-items-center justify-content-between">
                        <h4 className="event-alert p-0 mb-0">Customers</h4>
                      </div>
                      <table className="checklist-table remove-space">
                        <thead>
                          <tr>
                            <th>Category </th>
                            <th>Customer Name </th>
                            <th>Contact Name </th>
                            <th>Contact Phone Number </th>
                            <th>Contact Email </th>
                            <th class="action-td">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {customersData?.map((el) => (
                            <tr>
                              <td>{el?.category} </td>
                              <td>{el?.first_name + " " + el?.last_name} </td>
                              <td>{el?.contact_name} </td>
                              <td>{el?.contact_number} </td>
                              <td>{el?.contact_email} </td>
                              <td class="action-td">
                                <div
                                  onClick={() => {
                                    dispatch(
                                      actions?.getCustomerEditData({
                                        id: el?.id,
                                      })
                                    );
                                    history.push(
                                      "/order/customers/new-customer",
                                      "edit"
                                    );
                                  }}
                                  class="circle_icon"
                                >
                                  <a>
                                    <i class="iconSprites edit-icon"> </i>
                                  </a>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Customers;
